import * as React from 'react';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';
import { MediumHeader } from '@narvar/nth-bit-header';
import TextLink, { TextLinkTargetType } from '@narvar/nth-bit-text-link';
import useTempTranslations from '../useTempTranslations';
import CustomComponentContext from '../../CustomComponentContext';
import { FEDEX_DELIVERY_MANAGER_LINK } from '../../../lib/links';

interface PickupInstructionsProps {
  isRth: boolean;
}

const PickupInstructions: React.FunctionComponent<PickupInstructionsProps> = ({
  isRth,
}) => {
  const { track } = React.useContext(CustomComponentContext);

  const {
    bodytextDefaultNone: textStyle,
    linksNoneDefault: linkDefault,
    linksNoneHover: linkHover,
  } = useTheme();

  // TODO: update these values in nth-hook-translations and use that.
  // currently installing @latest results in react dependency conflicts.
  const {
    redirectToHoldPostSuccessPickupInstructionsHeader,
    redirectToHoldPostSuccessPickupInstructionsDescription,
    redirectToHoldPostSuccessPickupInstructionsLink,
    pickupLocationInstructions,
  } =
    useTempTranslations({
      translationKeys: [
        'redirectToHoldPostSuccessPickupInstructionsHeader',
        'redirectToHoldPostSuccessPickupInstructionsDescription',
        'redirectToHoldPostSuccessPickupInstructionsLink',
        'pickupLocationInstructions',
      ],
    }) || {};

  const handleClickDeliveryManagerLink = () => {
    track({
      eventType: 'click',
      clickSubType: 'external_link',
    });
  };

  return (
    <>
      <MediumHeader as="h3" containerCustomStyle={{ marginBottom: '0.5rem' }}>
        {redirectToHoldPostSuccessPickupInstructionsHeader}
      </MediumHeader>
      <div style={{ ...textStyle, marginBottom: '1rem' }}>
        {isRth
          ? redirectToHoldPostSuccessPickupInstructionsDescription
          : pickupLocationInstructions}
      </div>
      {isRth && (
        <TextLink
          linkStyle={{
            sDefault: linkDefault,
            sHover: linkHover,
          }}
          href={FEDEX_DELIVERY_MANAGER_LINK}
          target={TextLinkTargetType.BLANK}
          onClick={handleClickDeliveryManagerLink}
        >
          {redirectToHoldPostSuccessPickupInstructionsLink}
        </TextLink>
      )}
    </>
  );
};

export default withThemeProvider(PickupInstructions, {
  themeTokens: ['bodytextDefaultNone', 'linksNoneDefault', 'linksNoneHover'],
});
